var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "L_Illustration/Restaurant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "L_Illustration/Restaurant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E8E8E8",
    points: "1 18 23.001 18 23.001 3 1 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#2F2F36",
    points: "3 15 14 15 14 8 3 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#2F2F36",
    points: "16 18 21 18 21 8 16 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#3EA5CF",
    points: "0.9999 0.0002 -0.0001 3.0002 23.9999 3.0002 23.0009 0.0002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fillOpacity: 0.25,
    fill: "#000000",
    points: "23 3 1 3 1 18 14 18 23 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,17 L11,20 L17,20 L17,11 L15.82,11 C15.343,11 14.933,11.336 14.839,11.804 L14,16 L12,16 C11.448,16 11,16.448 11,17 Z M3,16 L2.161,11.804 C2.067,11.336 1.657,11 1.18,11 L0,11 L0,20 L6,20 L6,17 C6,16.448 5.552,16 5,16 L3,16 Z M5,15 L5,13 L12,13 L12,15 L5,15 Z M24,4.6265 C24,6.2835 22.657,7.6265 21,7.6265 C19.343,7.6265 18,6.2835 18,4.6265 C18,6.2835 16.657,7.6265 15,7.6265 C13.343,7.6265 12,6.2835 12,4.6265 C12,6.2835 10.657,7.6265 9,7.6265 C7.343,7.6265 6,6.2835 6,4.6265 C6,6.2835 4.657,7.6265 3,7.6265 C1.343,7.6265 0,6.2835 0,4.6265 L0,3.0005 L24,3.0005 L24,4.6265 Z",
    id: "Combined-Shape",
    fill: "#177796"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/Restaurant.5208539c10cacced966099a6cfe84abd.svg";
export { ForwardRef as ReactComponent };